<template>
  <div style="position: fixed; top: 40px; right: 20px; z-index: 1000;" v-if="kiosk.id !== null">
    <v-container
        class="px-0"
        fluid
    >
      <v-switch
          @change="switchKiosk"
          v-model="kiosk.isActive"
          :loading="isLoading"
          :disabled="isLoading"
          :label="`Kiosk: ${kiosk.isActive ? 'активний' : 'неактивний'}`"
      ></v-switch>
    </v-container>
  </div>
</template>

<script>
import apiService from "@/apiServices/apiService";

export default {
  name: "SwitchKiosk",
  props: {
    locationId: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      kiosk : {
        id: null,
        isActive: false
      },
      isLoading: false,

    };
  },
  methods: {
    async switchKiosk() {
      console.log('Switching kiosk mode. Current state:', this.kiosk.isActive);
      this.isLoading = true;
      try {
        const updateResponse = await apiService.editDevice({deviceId: this.kiosk.id, isActive: this.kiosk.isActive});
        if (updateResponse.success) {
          this.loading = false;
          this.$store.commit('setSnackMessage', {
            message: `Дані оновлено успішно 👍`,
            isError: false
          })
          this.deviceSettingDialog = false;
        } else {
          this.kiosk.isActive = !this.kiosk.isActive;
          this.isLoading = false;
          this.$store.commit('setSnackMessage', {
            message: `❕Халепа \n${updateResponse.error}`,
            isError: true
          })
          // alert(`Халепа ❗️\n\n${updateResponse.error}`)
        }
      } catch (e) {
        this.kiosk.isActive = !this.kiosk.isActive; // Revert the change on error
        this.$store.commit('setSnackMessage', {
          message: `❕${e}`,
          isError: true
        })
        this.isLoading = false;
      } finally {
        this.isLoading = false;
      }

    },

    getDeviceIdByLocationId(devices, locationId) {
      const device = devices.find(d => d.locationId === locationId && d.type === "KIOSK");
      return device ? {id: device.deviceId, isActive: device.isActive}: null;
    },

    async getDevices() {
      try {
        let devices = await apiService.getDevices();
        // console.log('DEVICES ----> ', devices);
        if ('msg' in devices) return false;
        this.isLoading = false;
        if (devices.success) {
          this.kiosk = this.getDeviceIdByLocationId(devices.devices, this.locationId);
          console.log('KIOSK ID ----> ', this.kiosk.id);
          console.log('KIOSK ACTIVE ----> ', this.kiosk.isActive);
        } else {
          alert(`Проблема отримання даних️ по кіоску\n${devices.error}`);

        }
      } catch (e) {
        this.$store.commit('setSnackMessage', {
          message: `Проблема отримання даних️\n${e}`,
          isError: true
        })
        this.isErrorGetData.state = true;
        this.isErrorGetData.errMsg = e;
        this.isLoading = false;
      }

    },
  },
  mounted() {
    this.getDevices();
  }
}
</script>

<style scoped>

</style>
